import { CssType, ThemeType } from '@theming/jssTypes';

export const styles = (theme: ThemeType): CssType => ({
  tableContainer: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
  },
  table: {
    marginLeft: theme.spacing[0],
  },
  timeline: {
    flex: '0.2 1 0%',
    margin: theme.spacing[2],
    padding: theme.spacing[2],
    border: `${theme.border.width.sm} solid ${theme.color.semantic.border.primary}`,
  },
  timelineWithLogs: {
    flex: '0.6 1 0%',
    marginLeft: theme.spacing[2],
    marginTop: theme.spacing[2],
    marginBottom: theme.spacing[2],
    flexDirection: 'column',
  },
  download: {
    flex: '0.03 1 0%',
    border: `${theme.border.width.sm} solid ${theme.color.semantic.border.primary}`,
  },
  distanceTable: {
    flex: '0.97 1 0%',
    '& tr': {
      verticalAlign: 'top',
      height: theme.spacing[1],
    },
    '& th': {
      verticalAlign: 'middle',
    },
    '& td': {
      verticalAlign: 'top',
    },
  },
  downloadText: {
    color: theme.color.semantic.text.primary,
    paddingLeft: theme.spacing[2],
    paddingRight: theme.spacing[2],
    fontSize: theme.typography.fontSize.sm,
    fontFamily: theme.typography.fontFamily.primary,
    fontStyle: 'italic',
    fontWeight: theme.typography.fontWeight.regular,
    wordWrap: 'break-word',
  },
  eventTime: {
    color: theme.color.semantic.text.primary,
    fontSize: theme.typography.fontSize.sm,
    fontFamily: theme.typography.fontFamily.primary,
    fontWeight: theme.typography.fontWeight.regular,
    wordWrap: 'break-word',
  },
  eventName: {
    color: theme.color.semantic.text.primary,
    fontSize: theme.typography.fontSize.sm,
    fontFamily: theme.typography.fontFamily.primary,
    fontWeight: theme.typography.fontWeight.semibold,
    wordWrap: 'break-word',
  },
  distanceTableData: {

  },
});
